export type CellSpan = { render: boolean; rowSpan: number };

/**
 * run（連続する同じ地点の明細行）の各行・各列の rowSpan。
 * groupBy 列は「連続する同値」だけをまとめる（値が変われば別セルに分割して欠落を防ぐ）。
 * 「元: 101-3」が違う行は表示値が同じでも結合しない（別の元コースの明細を 1 セルに混ぜない）。
 */
export function buildCellSpans(
  runVals: readonly (readonly string[])[],
  runOrigins: readonly (string | null)[],
  groupByFlags: readonly boolean[],
): CellSpan[][] {
  const sameRow = (a: number, b: number, ci: number) => runVals[a][ci] === runVals[b][ci] && runOrigins[a] === runOrigins[b];
  return runVals.map((vals, runIndex) => vals.map((_v, ci) => {
    if (!groupByFlags[ci]) return { render: true, rowSpan: 1 };
    if (runIndex > 0 && sameRow(runIndex - 1, runIndex, ci)) return { render: false, rowSpan: 1 };
    let rowSpan = 1;
    while (runIndex + rowSpan < runVals.length && sameRow(runIndex, runIndex + rowSpan, ci)) rowSpan += 1;
    return { render: true, rowSpan };
  }));
}
